import React from "react";
import { Card } from "@pancakeswap-libs/uikit";
import styled from "styled-components";
import "./index.css";

const StyledTwitterCard = styled(Card)`
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 20px;
  background: linear-gradient(
    162.44deg,
    #000000 49.97%,
    rgba(0, 0, 0, 0) 98.44%
  );
  border: 1px solid #ffffff;
  box-sizing: border-box;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  border-radius: 20px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .heading {
    font-size: 24px;
    margin-left: 50px;
  }

  @media (max-width: 600px) {
    flex-direction: column;
    justify-content: space-evenly;
    .heading {
      font-size: 20px;
      margin-left: auto;
      margin-right: auto;
    }
  }
  .Links {
    display: flex;
  }
`;

const Base = styled.div`
  width: 151px;
  height: 52px;
  background: linear-gradient(96.59deg, #939393 0%, #cfcfcf 100%);
  border-radius: 10px;
  margin: auto 35px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  color: black;

  @media (max-width: 600px) {
    width: 100px;
    height: 40px;
    margin: auto 3px;
    font-size: 12px;
    img {
      width: 20px;
    }
  @media (max-width: 375px) {
    width: 95px;
    height: 35px;
    margin: auto 3px;
    font-size: 10px;
    img {
      width: 20px;
    }
  }
  @media (max-width: 350px) {
    width: 90px;
    height: 35px;
    margin: auto 3px;
    font-size: 10px;
    img {
      width: 20px;
    }
  }
`;

const BuyVempLinks = () => {
  return (
    <StyledTwitterCard>
      <p className="heading">Buy VEMP</p>
      <div className="Links">
        <a
          href="https://app.uniswap.org/#/swap?outputCurrency=0xcfeb09c3c5f0f78ad72166d55f9e6e9a60e96eec&use=V2&chain=mainnet"
          target="_blank"
          rel="noreferrer"
        >
          <Base>
            <p>Buy $VEMP</p>
            <img src="/images/Uniswap.png" alt="Not Found" />
          </Base>
        </a>
        <a
          href="https://pancakeswap.finance/info/token/0xedf3ce4dd6725650a8e9398e5c6398d061fa7955"
          target="_blank"
          rel="noreferrer"
        >
          <Base>
            <p>Buy $VEMP</p>
            <img src="/images/pancakeswapCake.png" alt="Not Found" />
          </Base>
        </a>

        <a
          href="https://www.kucoin.com/trade/VEMP-USDT"
          target="_blank"
          rel="noreferrer"
        >
          <Base>
            <p>Buy $VEMP</p>
            <img
              src="/images/kucoin.png"
              alt="Not Found"
              style={{ height: "37px" }}
            />
          </Base>
        </a>
      </div>
    </StyledTwitterCard>
  );
};

export default BuyVempLinks;
